export class DateRange {
    public readonly startDate: Date;
    public readonly endDate: Date;

    constructor(date1: Date, date2: Date) {
        const dates: number[] = [date1.valueOf(), date2.valueOf()];
        this.startDate = new Date(Math.min(...dates));
        this.endDate = new Date(Math.max(...dates));
    }
}
